import UserFieldBase from "./base";

export default class UserFieldConfirm extends UserFieldBase {}
